import { fromJS } from 'immutable'
import {
  POSITION_EDIT_REQUEST,
  POSITION_EDIT_SUCCESS,
  POSITION_EDIT_FAILURE,
  POSITION_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_EDIT_SUCCESS:
      return state
        .set('positionEdit', fromJS(action.payload.updatedPosition))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case POSITION_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('positionEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case POSITION_EDIT_RESET:
      return state
        .delete('positionEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-edit-reducer.js